var rich_content_viewer_default = {
  "fontElementMap": "_2o3GI",
  "wrapper": "IZZyL",
  "pluginContainerMobile": "wy8OF",
  "viewer": "C1GRG",
  "android": "IWN2B",
  "rootedTraversedContent": "-wMyf",
  "atomic": "_312Px",
  "toolbar": "-KhsL",
  "block": "_3Kp4F"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
